import { FC, useEffect, useState } from 'react';

import { push } from 'connected-react-router';
import { getAuctionEditUrl } from 'utils/auction';
import { formatCost, isAccountStatusReadOnly } from 'utils/clickme';
import { CAMPAIGN_LOW_BALANCE } from 'utils/constants/campaign';

import { Link } from '@hh.ru/redux-spa-middleware';

import Button, { ButtonKind } from 'bloko/blocks/button';
import BlokoLink from 'bloko/blocks/link';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { useDispatch, useSelector } from 'store/utils';

interface CampaignBalanceLinkProps {
    campaignId: number;
    balance: number;
    budget: number;
    isAuction: boolean;
    vacancyId: number | null;
}

const CampaignBalanceLink: FC<CampaignBalanceLinkProps> = ({ campaignId, balance, budget, isAuction, vacancyId }) => {
    const currentAccountStatus = useSelector((state) => state.user.user?.currentAccount.status);

    const LINK = isAuction ? getAuctionEditUrl(vacancyId) : `/new/campaign/${campaignId}?step=1`;

    const dispatch = useDispatch();

    const [isShowInformer, setShowInformer] = useState(false);

    const trl = useTrls();

    useEffect(() => {
        if (balance < CAMPAIGN_LOW_BALANCE) {
            setShowInformer(true);
        }
    }, [balance]);

    if (isAccountStatusReadOnly(currentAccountStatus)) {
        return null;
    }

    return (
        <div>
            <Text>{trl('campaign.balance.title')}</Text>
            <VSpacing base={1} />
            <BlokoLink Element={Link} to={LINK}>
                {trl('campaign.balance.link', [formatCost(balance), formatCost(budget)])}
            </BlokoLink>
            {isShowInformer && !isAuction && (
                <>
                    <VSpacing base={4} />
                    <Button kind={ButtonKind.Primary} onClick={() => dispatch(push(LINK))}>
                        {trl('campaign.balance.button')}
                    </Button>
                </>
            )}
        </div>
    );
};

export default CampaignBalanceLink;
